export const MINOR_INFO_TABS = {
  patient: { id: "patient", titleStringId: "patient" },
  contact: { id: "contact", titleStringId: "contact" },
};
